import { UserType } from "../types";

// Helper function to determine if a color is light or dark
export const getContrastColor = (inputColor: string) => {
    // Accepts "#RRGGBB", "RRGGBB", or falls back for non-hex values
    const normalized = inputColor?.trim() || "";
    const hex = normalized.startsWith("#") ? normalized.slice(1) : normalized;

    // Expand shorthand hex (#RGB -> #RRGGBB)
    const fullHex =
        /^[0-9a-fA-F]{3}$/.test(hex)
            ? hex.split("").map((c) => c + c).join("")
            : hex;

    // If not valid 6-digit hex, use a safe default
    if (!/^[0-9a-fA-F]{6}$/.test(fullHex)) {
        return "#232323";
    }

    const r = parseInt(fullHex.slice(0, 2), 16);
    const g = parseInt(fullHex.slice(2, 4), 16);
    const b = parseInt(fullHex.slice(4, 6), 16);

    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 155 ? "#232323" : "#ffffff";
}

export type AdminUserFilter = "All" | "Active" | UserType;

export const getUserTypeColor = (userType: AdminUserFilter) => {
    if (userType == "All") {
        return "primary.main"
    }

    if (userType == "Active") {
        return "primary.main"
    }

    switch (userType) {
        case UserType.SysAdmin:
            return "error.main";
        case UserType.DeveloperAdmin:
            return "secondary.main";
        case UserType.OrgAdmin:
            return "warning.main";
        case UserType.User:
            return "primary.main";
        case UserType.Guest:
            return "text.disabled";
        case UserType.Inactive:
            return "text.secondary";
        case UserType.Blocked:
            return "text.secondary";
        default:
            return "text.disabled";
    }
};